import { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { ColumnsPhotoAlbum } from "react-photo-album";
import { isMobile } from 'react-device-detect'

import Container from 'react-bootstrap/Container'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Carousel from 'react-bootstrap/Carousel'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'

import { Facebook, Instagram, Linkedin, Tiktok } from 'react-bootstrap-icons';

import logo from './img/logo.png'
import mglogo from './img/mg_logo.png'
import slide01 from './img/slider01.jpg'
import motiva from './img/icono_motiva.png'
import arrows from './img/arrows_down.png'

import arquitectura from './img/icons/arquitectura.png'
import disenoarq from './img/icons/disenoarq.png'
import interiorismo from './img/icons/interiorismo.png'
import mantenimiento from './img/icons/mantenimiento.png'
import menores from './img/icons/menores.png'
import mobiliario from './img/icons/mobiliario.png'
import render from './img/icons/render.png'
import supervision from './img/icons/supervision.png'

import activaciones from './img/icons/activaciones.png'
import industria from './img/icons/industria.png'
import retail from './img/icons/retail.png'
import salud from './img/icons/salud.png'

import 'bootstrap/dist/css/bootstrap.min.css'
import "react-photo-album/columns.css";
import './App.css'

const host = 'https://motivastudio.com.mx/'
//const host = 'http://localhost:3000/'

const ITEMS_US = [
  {
    src: host + 'projects/activaciones.jpg',
    width: 1200,
    height: 1595,
    icon: activaciones,
    title: 'Activaciones y Experiencias',
    desc: 'Entornos inversivos, creativos y memorables que dominan la atención en eventos y festivales.'
  },
  {
    src: host + 'projects/menores.jpg',
    width: 1200,
    height: 1514,
    icon: menores,
    title: 'Servicios Menores',
    desc: 'Mantenimiento práctico y de calidad: pintura, impermeabilización, plomería y reparaciones menores.'
  },
  {
    src: host + 'projects/supervision.jpg',
    width: 1200,
    height: 1595,
    icon: supervision,
    title: 'Supervisión y ejecución de obra',
    desc: 'Coordinación y control del proyecto en campo hasta su entrega.'
  }
]
const ITEMS_US_2 = [
  {
    src: host + 'projects/interiorismo.jpg',
    width: 1200,
    height: 1595,
    icon: interiorismo,
    title: 'Interiorismo',
    desc: 'Ambientación, mobiliario y acabados que reflejan tu identidad.'
  },
  {
    src: host + 'projects/arquitectura.jpg',
    width: 1200,
    height: 1514,
    icon: arquitectura,
    title: 'Arquitectura comercial',
    desc: 'Diseño de oficinas, locales, restaurantes, consultorios, etc.'
  },
  {
    src: host + 'projects/disenoarq.jpg',
    width: 1200,
    height: 1595,
    icon: disenoarq,
    title: 'Diseño arquitectónico residencial',
    desc: 'Casas, departamentos, remodelaciones y ampliaciones.'
  },

]
const ITEMS_US_3 = [
  {
    src: host + 'projects/render.jpg',
    width: 1200,
    height: 2141,
    icon: render,
    title: 'Renderizado y visualización 3D',
    desc: 'Propuestas visuales realistas para tomar decisiones seguras.'
  },
  {
    src: host + 'projects/mobiliario.jpg',
    width: 1200,
    height: 1514,
    icon: mobiliario,
    title: 'Mobiliario',
    desc: 'Desde soluciones comerciales personalizadas, hasta mobiliario residencial.'
  },
  {
    src: host + 'projects/industria.jpg',
    width: 1200,
    height: 2141,
    icon: industria,
    title: 'Innovación e industria',
    desc: 'Estructuras sólidas y de gran formato específicamente para maquinaria pesada.'
  }
]
const ITEMS_US_4 = [
  {
    src: host + 'projects/retail.jpg',
    width: 1200,
    height: 1595,
    icon: retail,
    title: 'Retail y Estilo de vida',
    desc: 'Espacios tipo boutique, enfocados en la elevación de la experiencia del consumidor.'
  },
  {
    src: host + 'projects/mantenimiento.jpg',
    width: 1200,
    height: 1514,
    icon: mantenimiento,
    title: 'Mantenimiento',
    desc: 'Cuidado profesional de espacios arquitectónicos, seguros y eficientes.'
  },
  {
    src: host + 'projects/salud.jpg',
    width: 1200,
    height: 1595,
    icon: salud,
    title: 'Salud, Farma y Bienestar',
    desc: 'Diseños limpios que priorizan la iluminación y exhibición del producto.'
  }
]

function App() {
  const [isLoading, setLoading] = useState(false)
  const [name, setName] = useState("")
  const [phone, setPhone] = useState("")
  const [email, setEmail] = useState("")
  const [comments, setComments] = useState("")

  const [showMessage, setShowMessage] = useState(false)
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')

  const refHome = useRef()
  const refUs = useRef()
  const refGallery = useRef()
  const refServices = useRef()
  const refContact = useRef()

  const _itemLarge = ITEMS_US[0];
  const _itemSmall1 = ITEMS_US_2[0];
  const _itemSmall2 = ITEMS_US_2[1];
  const _itemSmall3 = ITEMS_US_2[2];
  const _itemRight1 = ITEMS_US[1];
  const _itemRight2 = ITEMS_US[2];

  const itemLarge = ITEMS_US_3[0];
  const itemSmall1 = ITEMS_US_4[0];
  const itemSmall2 = ITEMS_US_4[1];
  const itemSmall3 = ITEMS_US_4[2];
  const itemRight1 = ITEMS_US_3[1];
  const itemRight2 = ITEMS_US_3[2];

  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    }

    // load the script by passing the URL
    loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=6Lfay-sgAAAAAKMr9fFh6dAgAQ72hqP64TVuAAk5`, function () {
      console.log("Script loaded!");
    });
  }, []);

  const handleClick = (eventKey) => {
    console.log("eventKey", eventKey)

    var element = eval(eventKey).current;
    var headerOffset = 90;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });

  };

  const handleOnSubmit = (event) => {
    event.preventDefault();

    window.grecaptcha.ready(() => {
      window.grecaptcha.execute("6Lfay-sgAAAAAKMr9fFh6dAgAQ72hqP64TVuAAk5", { action: 'submit' }).then(token => {
        //if(isVerified){
        setLoading(true);
        //const recaptchaValue = recaptchaRef.current.getValue();
        var form = document.getElementById("contactForm");
        var formData = new FormData(form);
        formData.append('recaptcha_response', token);

        setLoading(true);
        axios.post("https://inmobiplace.com/api/contactMG", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function (response) {

          if (response.data == "FAIL" || response.data == "ERROR") {
            setLoading(false)
            setTitle("Error")
            setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
            handleShow()
          } else {
            //window.location.href = "/gracias"
            setLoading(false)
            setTitle("Mensaje enviado")
            setMessage("Tu mensaje ha sido enviado. En breve nos comunicaremos contigo. Gracias.");
            handleShow()

            setName("");
            setPhone("");
            setEmail("");
            setComments("");
          }

        }).catch(function (err) {
          setLoading(false)
          setTitle("Error")
          setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
          handleShow()
        });
        //} else 
        //alert("Por favor, verifica que no eres un robot")
      });
    });
  }

  const handleShow = () => setShowMessage(true);

  const closeModalSent = () => {
    /*if( title == 'Error') setShowMessage(false)
    else window.location.href = "/"*/
    setShowMessage(false)
  }

  return (
    <div>
      <Modal show={showMessage} onHide={() => closeModalSent()}>
        <Modal.Header style={{ background: "#fff" }} closeButton>
          <Modal.Title style={{ color: "#000" }}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ color: "#000", background: "#fff" }}>{message}</Modal.Body>
        <Modal.Footer style={{ color: "#000", background: "#fff" }}>
          <Button variant="secondary" onClick={() => closeModalSent()}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>

      <video
        src="/motiva.mp4"
        autoPlay
        loop
        muted
        playsInline
        className="player-style"
      />

      <div className="sub-navbar-container">
        <div className="container d-flex flex-column flex-md-row justify-content-around align-items-center py-3">
          <a onClick={() => handleClick('refUs')} className="nav-custom-link my-2 my-md-0">NOSOTROS</a>
          <a onClick={() => handleClick('refServices')} className="nav-custom-link my-2 my-md-0">SERVICIOS</a>
          <a onClick={() => handleClick('refContact')} className="nav-custom-link my-2 my-md-0">CONTACTO</a>
        </div>
      </div>

      <div style={{ background: '#d0c3b0' }}>
        <div ref={refGallery} className='section section-arena'>
          <Container className='p-0 us-container'>
            <Row className='align-items-center'>
              <Col md={4} className={isMobile ? 'mov-hidden' : ''}>
                <div>
                  <img src={motiva} style={{ width: '80%' }} />
                </div>
              </Col>
              <Col md={8} xs={12} align="center">
                <div className='ps-5 section-title-container'>
                  <div style={{ width: '100%' }}>
                    <div className='section-title section-title-home-small'> Diseñamos espacios </div>
                    <div className='section-title section-title-home'> que inspiran </div>
                  </div>
                </div>
                <br />
                <div style={isMobile ? { width: '100%' } : { width: '80%' }}>
                  <div className='home-text-home' style={{ color: '#fff' }}>
                    <span style={{ fontFamily: 'MundialBold' }}>Transformamos tu marca en una experiencia mediante diseño y fabricación de vanguardia.</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div ref={refServices} className='section section-arena' style={isMobile ? { borderEndStartRadius: '50px', borderEndEndRadius: '50px', paddingTop: 0 } : { borderEndStartRadius: '100px', borderEndEndRadius: '100px', paddingTop: 0 }} align="center">
          <Container className="bento-gallery-container">
            <Row className="g-4 h-100">
              {/* Columna Izquierda */}
              <Col lg={8} xs={12} className="d-flex flex-column justify-content-between">
                <Row className="g-4 flex-grow-1">
                  {/* Imagen Principal Grande */}
                  <Col xs={12}>
                    <div className="bento-card bento-card-main">
                      <img src={_itemLarge?.src} alt={_itemLarge?.title} className="bento-img" />
                      <div className="photo-overlay">
                        {_itemLarge?.icon && <div><img className="photo-icon" src={_itemLarge.icon} /></div>}
                        {_itemLarge?.title && <h4 className="photo-title">{_itemLarge.title}</h4>}
                        {_itemLarge?.desc && <p className="photo-desc">{_itemLarge.desc}</p>}
                      </div>
                    </div>
                  </Col>

                  {/* Las 3 imágenes pequeñas inferiores */}
                  <Col xs={12} md={4}>
                    <div className="bento-card bento-card-sm">
                      <img src={_itemSmall1?.src} alt="Gallery 1" className="bento-img" />
                      <div className="photo-overlay photo-overlay-sm">
                        {_itemSmall1?.icon && <div><img className="photo-icon" src={_itemSmall1.icon} /></div>}
                        {_itemSmall1?.title && <h4 className="photo-title photo-title-sm">{_itemSmall1.title}</h4>}
                        {_itemSmall1?.desc && <p className="photo-desc photo-desc-sm">{_itemSmall1.desc}</p>}
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div className="bento-card bento-card-sm">
                      <img src={_itemSmall2?.src} alt="Gallery 2" className="bento-img" />
                      <div className="photo-overlay photo-overlay-sm">
                        {_itemSmall2?.icon && <div><img className="photo-icon" src={_itemSmall2.icon} /></div>}
                        {_itemSmall2?.title && <h4 className="photo-title photo-title-sm">{_itemSmall2.title}</h4>}
                        {_itemSmall2?.desc && <p className="photo-desc photo-desc-sm">{_itemSmall2.desc}</p>}
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <div className="bento-card bento-card-sm">
                      <img src={_itemSmall3?.src} alt="Gallery 3" className="bento-img" />
                      <div className="photo-overlay photo-overlay-sm">
                        {_itemSmall3?.icon && <div><img className="photo-icon" src={_itemSmall3.icon} /></div>}
                        {_itemSmall3?.title && <h4 className="photo-title photo-title-sm">{_itemSmall3.title}</h4>}
                        {_itemSmall3?.desc && <p className="photo-desc photo-desc-sm">{_itemSmall3.desc}</p>}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>

              {/* Columna Derecha (2 elementos que deben equilibrar la altura de la izquierda) */}
              <Col lg={4} xs={12} className="d-flex flex-column">
                <div className="bento-card bento-card-right flex-grow-1 mb-4">
                  <img src={_itemRight1?.src} alt="Gallery Right 1" className="bento-img" />
                  <div className="photo-overlay">
                    {_itemRight1?.icon && <div><img className="photo-icon" src={_itemRight1.icon} /></div>}
                    {_itemRight1?.title && <h4 className="photo-title">{_itemRight1.title}</h4>}
                    {_itemRight1?.desc && <p className="photo-desc">{_itemRight1.desc}</p>}
                  </div>
                </div>
                <div className="bento-card bento-card-right flex-grow-1">
                  <img src={_itemRight2?.src} alt="Gallery Right 2" className="bento-img" />
                  <div className="photo-overlay">
                    {_itemRight2?.icon && <div><img className="photo-icon" src={_itemRight2.icon} /></div>}
                    {_itemRight2?.title && <h4 className="photo-title">{_itemRight2.title}</h4>}
                    {_itemRight2?.desc && <p className="photo-desc">{_itemRight2.desc}</p>}
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          {/*<Container className="gallery-container">
            <ColumnsPhotoAlbum
              photos={ITEMS_US}
              columns={isMobile ? 1 : 2}
              render={{
                // render.extras inyecta el overlay dentro del contenedor nativo de la foto
                extras: (_, { photo }) => (
                  <div className="photo-overlay">
                    {photo?.icon && <div><img className="photo-icon" src={photo.icon} /></div>}
                    {photo?.title && <h4 className="photo-title">{photo.title}</h4>}
                    {photo?.desc && <p className="photo-desc">{photo.desc}</p>}
                  </div>
                ),
              }}
            />
          </Container>

          <Container className="gallery-container">
            <ColumnsPhotoAlbum
              photos={ITEMS_US_2}
              columns={isMobile ? 1 : 3}
              render={{
                // render.extras inyecta el overlay dentro del contenedor nativo de la foto
                extras: (_, { photo }) => (
                  <div className="photo-overlay">
                    {photo?.icon && <div><img className="photo-icon" src={photo.icon} /></div>}
                    {photo?.title && <h4 className="photo-title">{photo.title}</h4>}
                    {photo?.desc && <p className="photo-desc">{photo.desc}</p>}
                  </div>
                ),
              }}
            />
          </Container>*/}
        </div>

        <div className='section section-gradient pt-0' style={{ paddingBottom: 0 }} align="center">
          <Container>
            <div> <img src={arrows} className='arrow-icon' /> </div>
            <div className='arrows-text'>
              <div style={{ color: '#444' }}>Nos impulsa la pasión por crear espacios funcionales, estéticos y únicos que respondan con precisión a las necesidades de cada cliente. </div>

              <div
                className='section section-arena py-5'
                style={isMobile ? { borderStartStartRadius: '50px', borderStartEndRadius: '50px' } : { borderStartStartRadius: '100px', borderStartEndRadius: '100px' }}
              >
                <Container className="bento-gallery-container">
                  <Row className="g-4 h-100">
                    {/* Columna Izquierda */}
                    <Col lg={8} xs={12} className="d-flex flex-column justify-content-between">
                      <Row className="g-4 flex-grow-1">
                        {/* Imagen Principal Grande */}
                        <Col xs={12}>
                          <div className="bento-card bento-card-main">
                            <img src={itemLarge?.src} alt={itemLarge?.title} className="bento-img" />
                            <div className="photo-overlay">
                              {itemLarge?.icon && <div><img className="photo-icon" src={itemLarge.icon} /></div>}
                              {itemLarge?.title && <h4 className="photo-title">{itemLarge.title}</h4>}
                              {itemLarge?.desc && <p className="photo-desc">{itemLarge.desc}</p>}
                            </div>
                          </div>
                        </Col>

                        {/* Las 3 imágenes pequeñas inferiores */}
                        <Col xs={12} md={4}>
                          <div className="bento-card bento-card-sm">
                            <img src={itemSmall1?.src} alt="Gallery 1" className="bento-img" />
                            <div className="photo-overlay photo-overlay-sm">
                              {itemSmall1?.icon && <div><img className="photo-icon" src={itemSmall1.icon} /></div>}
                              {itemSmall1?.title && <h4 className="photo-title photo-title-sm">{itemSmall1.title}</h4>}
                              {itemSmall1?.desc && <p className="photo-desc photo-desc-sm">{itemSmall1.desc}</p>}
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} md={4}>
                          <div className="bento-card bento-card-sm">
                            <img src={itemSmall2?.src} alt="Gallery 2" className="bento-img" />
                            <div className="photo-overlay photo-overlay-sm">
                              {itemSmall2?.icon && <div><img className="photo-icon" src={itemSmall2.icon} /></div>}
                              {itemSmall2?.title && <h4 className="photo-title photo-title-sm">{itemSmall2.title}</h4>}
                              {itemSmall2?.desc && <p className="photo-desc photo-desc-sm">{itemSmall2.desc}</p>}
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} md={4}>
                          <div className="bento-card bento-card-sm">
                            <img src={itemSmall3?.src} alt="Gallery 3" className="bento-img" />
                            <div className="photo-overlay photo-overlay-sm">
                              {itemSmall3?.icon && <div><img className="photo-icon" src={itemSmall3.icon} /></div>}
                              {itemSmall3?.title && <h4 className="photo-title photo-title-sm">{itemSmall3.title}</h4>}
                              {itemSmall3?.desc && <p className="photo-desc photo-desc-sm">{itemSmall3.desc}</p>}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>

                    {/* Columna Derecha (2 elementos que deben equilibrar la altura de la izquierda) */}
                    <Col lg={4} xs={12} className="d-flex flex-column">
                      <div className="bento-card bento-card-right flex-grow-1 mb-4">
                        <img src={itemRight1?.src} alt="Gallery Right 1" className="bento-img" />
                        <div className="photo-overlay">
                          {itemRight1?.icon && <div><img className="photo-icon" src={itemRight1.icon} /></div>}
                          {itemRight1?.title && <h4 className="photo-title">{itemRight1.title}</h4>}
                          {itemRight1?.desc && <p className="photo-desc">{itemRight1.desc}</p>}
                        </div>
                      </div>
                      <div className="bento-card bento-card-right flex-grow-1">
                        <img src={itemRight2?.src} alt="Gallery Right 2" className="bento-img" />
                        <div className="photo-overlay">
                          {itemRight2?.icon && <div><img className="photo-icon" src={itemRight2.icon} /></div>}
                          {itemRight2?.title && <h4 className="photo-title">{itemRight2.title}</h4>}
                          {itemRight2?.desc && <p className="photo-desc">{itemRight2.desc}</p>}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          </Container>
        </div>

        {/*<div className='section section-arena' style={isMobile ? { borderStartStartRadius: '50px', borderStartEndRadius: '50px' } : { borderStartStartRadius: '100px', borderStartEndRadius: '100px' }} align="center">
          <Container className="gallery-container">
            <ColumnsPhotoAlbum
              photos={ITEMS_US_3}
              columns={isMobile ? 1 : 2}
              render={{
                // render.extras inyecta el overlay dentro del contenedor nativo de la foto
                extras: (_, { photo }) => (
                  <div className="photo-overlay">
                    {photo?.icon && <div><img className="photo-icon" src={photo.icon} /></div>}
                    {photo?.title && <h4 className="photo-title">{photo.title}</h4>}
                    {photo?.desc && <p className="photo-desc">{photo.desc}</p>}
                  </div>
                ),
              }}
            />
          </Container>

          <Container className="gallery-container">
            <ColumnsPhotoAlbum
              photos={ITEMS_US_4}
              columns={isMobile ? 1 : 3}
              render={{
                // render.extras inyecta el overlay dentro del contenedor nativo de la foto
                extras: (_, { photo }) => (
                  <div className="photo-overlay">
                    {photo?.icon && <div><img className="photo-icon" src={photo.icon} /></div>}
                    {photo?.title && <h4 className="photo-title">{photo.title}</h4>}
                    {photo?.desc && <p className="photo-desc">{photo.desc}</p>}
                  </div>
                ),
              }}
            />
          </Container>
        </div>*/}
      </div>

      <div className='section' style={{ background: '#444444' }} ref={refContact}>
        <div className='section-title' style={{ textAlign: 'center', color: '#d0c3b0CC' }}> ¿Necesitas más información? </div>
        <br />
        <Container>
          <Row className='align-items-center'>
            <Col md={12}>
              <div align="center">
                <div className='form-container'>
                  <Form id="contactForm" onSubmit={handleOnSubmit}>
                    <Form.Group className="mb-4" controlId="exampleForm.ControlInput1">
                      <Form.Label></Form.Label>
                      <Form.Control required type="text" className='form-footer mb-4' placeholder="Nombre completo" name='name' value={name} onChange={() => setName()} />
                      <Form.Control required type="email" className='form-footer mb-4' placeholder="Correo electrónico" name='email' value={email} onChange={() => setEmail()} />
                      <Form.Control required type="number" className='form-footer mb-4' placeholder="Número telefónico" name='phone' value={phone} onChange={() => setPhone()} />
                    </Form.Group>
                    <Form.Group className="mb-4" controlId="exampleForm.ControlTextarea1">
                      <Form.Control required as="textarea" className='form-footer' placeholder="Mensaje" rows={3} name='comments' value={comments} onChange={() => setComments()} />
                    </Form.Group>
                    <div align="center"><Button disabled={isLoading} className="button-footer" type="submit" >{isLoading ? 'ENVIANDO...' : 'ENVIAR'}</Button></div>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className='section section-footer'>
        <Container className='form-container'>
          <Row>
            <Col md={'auto'}>
              <div align={isMobile ? 'center' : "right"} className='footer-container'>
                <img src={logo} className='logo' />
              </div>
            </Col>
            <Col>
              <div className='footer-container'>
                <div className='footer-text' align={isMobile ? 'center' : "left"}> Ciudad Satélite, Estado de México </div>
                <br />
                <div className='footer-text' align={isMobile ? 'center' : "left"}> <a href="tel:5582008025" target='_blank'> 55 8200 8025 </a> </div>
                <div className='footer-text' align={isMobile ? 'center' : "left"}> <a href="mailto:hola@motivastudio.mx" target='_blank'> hola@motivastudio.mx </a> </div>
                <br />
                <div align={isMobile ? 'center' : "left"}>
                  <a href='https://www.facebook.com/share/16TsyvDcHk/?mibextid=wwXIfr' target='_blank'><Facebook className='footer-icons' /></a>
                  <a href='https://www.instagram.com/motivastudio.oficial?igsh=M3MyZzE4MWxoZ3F0' target='_blank'> <Instagram className='footer-icons' /></a>
                  <a href='https://www.tiktok.com/@motivastudio_?_t=ZS-8ycuqT7auIS&_r=1' target='_blank'><Tiktok className='footer-icons' /></a>
                  <a href='https://www.linkedin.com/company/motivastudio/' target='_blank'><Linkedin className='footer-icons' /></a>
                </div>
              </div>
            </Col>
          </Row>
          <Row className='align-items-center'>
            <Col md={5}>
              <div align={isMobile ? 'center' : "right"} className='footer-container'>
                <img src={mglogo} className='mglogo' />
              </div>
            </Col>
            <Col>
              <div className='footer-container'>
                <div align={isMobile ? 'center' : "left"}>
                  <a href='https://mgmarketinggroup.com.mx/' target='_blank'><div className='footer-team'> By Marketing Group </div></a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

    </div>
  );
}

export default App;
